"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _customerOrderApi = require("@/api/customerOrderApi");
var _cardCouponApi = require("@/api/cardCouponApi");
var _shopIntegralApi = require("@/api/shopIntegralApi");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var EXCHANGE_TYPE = {
  POINTS_ONLY: 1,
  POINTS_CASH: 2,
  POINTS_CARD_CASH: 3
};
var defaultFukaRow = function defaultFukaRow() {
  return {
    fukaIds: [],
    pointsPercent: undefined,
    cashPercent: undefined,
    integralPerYuan: undefined
  };
};
var defaultFormData = function defaultFormData() {
  return {
    id: '',
    activityName: '',
    goodsType: '',
    activityTime: [],
    /** 0 全选适用分销客户，1 部分选择 */
    applyCustomerType: 0,
    cardPermissionIds: [],
    exchangeMode: 'POINTS_CARD_CASH',
    simpleRule: {
      pointsPercent: undefined,
      cashPercent: undefined,
      integralPerYuan: undefined
    },
    /** 兑换方式为「积分」时，元与积分的换算（与接口 details[].integralPerYuan 对应） */
    integralPerYuan: undefined,
    fukaRuleRows: [defaultFukaRow()],
    customerScope: []
  };
};
var _default = exports.default = {
  name: 'ExchangeConfigOperate',
  data: function data() {
    return {
      /** 兑换比例联动：避免 @change 互相触发死循环 */
      _syncingExchangePercent: false,
      currentStep: 0,
      mode: 'create',
      detailLoading: false,
      submitLoading: false,
      detailRequestToken: 0,
      formData: defaultFormData(),
      cardPermissionOptions: [],
      cardPermLoading: false,
      cardMetaMap: {},
      customerOptions: [],
      customerLoading: false,
      /** 活动时间：禁选过去日期 + 禁选当前时刻之前（打开面板时刷新 selectableRange） */
      activityTimePickerOptions: {},
      /** 范围选择器选日期时的默认时刻（用户可再改结束时分秒，不再强制改回 23:59:59） */
      activityTimeDefaultRange: ['00:00:00', '23:59:59'],
      rules: {
        activityName: [{
          validator: function validator(rule, value, callback) {
            if (value == null || String(value).trim() === '') {
              callback(new Error('请输入活动名称'));
            } else {
              callback();
            }
          },
          trigger: ['blur', 'change']
        }],
        goodsType: [{
          required: true,
          message: '请选择商品类型',
          trigger: 'change'
        }],
        activityTime: [{
          type: 'array',
          required: true,
          message: '请选择活动时间',
          trigger: 'change'
        }],
        exchangeMode: [{
          required: true,
          message: '请选择兑换方式',
          trigger: 'change'
        }]
      }
    };
  },
  computed: {
    isView: function isView() {
      return this.mode === 'view';
    },
    exchangeOperatePerms: function exchangeOperatePerms() {
      return this.mode === 'edit' && this.formData.id ? ['admin:shopintegral:activity:updateExchangeActivity'] : ['admin:shopintegral:activity:addExchangeActivity'];
    },
    mergedCardPermissionOptions: function mergedCardPermissionOptions() {
      var _this = this;
      var map = new Map();
      (this.cardPermissionOptions || []).forEach(function (item) {
        if (item && item.id != null) map.set(item.id, item);
      });
      (this.formData.cardPermissionIds || []).forEach(function (id) {
        if (!map.has(id) && _this.cardMetaMap[id]) {
          map.set(id, _this.cardMetaMap[id]);
        }
      });
      return Array.from(map.values());
    },
    /** 商品类型为优惠券商品（value=3） */isCouponGoodsType: function isCouponGoodsType() {
      return String(this.formData.goodsType) === '3';
    }
  },
  watch: {
    /** 与 AppMain :key="$route.name" 搭配时，同 name 复用实例不会走 created，需随路由刷新详情 */
    '$route': {
      immediate: true,
      handler: function handler(to) {
        if (to.name !== 'exchangeConfigOperate') return;
        this.initPageState();
      }
    }
  },
  created: function created() {
    this.resetActivityTimePickerOptions();
    this.searchCustomerOptions('');
    this.searchCardPermissionOptions('');
  },
  methods: {
    resetActivityTimePickerOptions: function resetActivityTimePickerOptions() {
      var fmt = function fmt(d) {
        var p = function p(n) {
          return String(n).padStart(2, '0');
        };
        return "".concat(d.getFullYear(), "-").concat(p(d.getMonth() + 1), "-").concat(p(d.getDate()), " ").concat(p(d.getHours()), ":").concat(p(d.getMinutes()), ":").concat(p(d.getSeconds()));
      };
      var now = new Date();
      var end = new Date(2099, 11, 31, 23, 59, 59);
      this.activityTimePickerOptions = {
        disabledDate: function disabledDate(time) {
          var dayStart = new Date(time.getFullYear(), time.getMonth(), time.getDate(), 0, 0, 0, 0);
          var todayStart = new Date();
          todayStart.setHours(0, 0, 0, 0);
          return dayStart.getTime() < todayStart.getTime();
        },
        selectableRange: "".concat(fmt(now), " - ").concat(fmt(end))
      };
    },
    onActivityTimePickerVisible: function onActivityTimePickerVisible(visible) {
      if (visible && this.mode !== 'edit') {
        this.resetActivityTimePickerOptions();
      }
    },
    initPageState: function initPageState() {
      this.mode = this.$route.params.mode || 'create';
      var routeId = this.$route.params.id || '';
      this.resetOperateFormState();
      if (routeId) {
        this.loadActivityDetail(routeId);
      }
    },
    resetOperateFormState: function resetOperateFormState() {
      var _this2 = this;
      this.currentStep = 0;
      this.formData = defaultFormData();
      this.$nextTick(function () {
        if (_this2.$refs.baseForm) {
          _this2.$refs.baseForm.clearValidate();
        }
      });
    },
    /** 从详情 DTO 解析兑换方式 */exchangeTypeToMode: function exchangeTypeToMode(exchangeType) {
      var t = Number(exchangeType);
      if (t === 1) return 'POINTS_ONLY';
      if (t === 3) return 'POINTS_CARD_CASH';
      return 'POINTS_CASH';
    },
    /**
     * 福卡规则回显：优先新接口 details[].cardIds；
     * 兼容旧数据按每条 cardId 展开的多条 detail。
     */
    buildFukaRowsFromDetails: function buildFukaRowsFromDetails(details) {
      var list = Array.isArray(details) ? details : [];
      if (!list.length) {
        return [defaultFukaRow()];
      }
      var hasNewCardIds = list.some(function (d) {
        return d && Array.isArray(d.cardIds);
      });
      if (hasNewCardIds) {
        var rows = list.filter(function (d) {
          return d && Array.isArray(d.cardIds) && d.cardIds.length;
        }).map(function (d) {
          return {
            fukaIds: d.cardIds.map(function (x) {
              return Number(x);
            }),
            pointsPercent: d.integralPercent,
            cashPercent: d.otherPayPercent,
            integralPerYuan: d.integralPerYuan
          };
        });
        return rows.length ? rows : [defaultFukaRow()];
      }
      var withCard = list.filter(function (d) {
        return d != null && d.cardId != null && d.cardId !== '';
      });
      if (!withCard.length) {
        return [defaultFukaRow()];
      }
      var sorted = _toConsumableArray(withCard).sort(function (a, b) {
        return (a.sort != null ? a.sort : 0) - (b.sort != null ? b.sort : 0);
      });
      var groups = [];
      var keyToIndex = new Map();
      sorted.forEach(function (d) {
        var key = "".concat(Number(d.integralPercent), "-").concat(Number(d.otherPayPercent));
        var idx = keyToIndex.get(key);
        if (idx === undefined) {
          idx = groups.length;
          keyToIndex.set(key, idx);
          groups.push({
            fukaIds: [],
            pointsPercent: d.integralPercent,
            cashPercent: d.otherPayPercent,
            integralPerYuan: d.integralPerYuan
          });
        }
        groups[idx].fukaIds.push(Number(d.cardId));
      });
      return groups.length ? groups : [defaultFukaRow()];
    },
    mergeCustomerOptionsFromDetail: function mergeCustomerOptionsFromDetail(data) {
      var byId = new Map((this.customerOptions || []).map(function (x) {
        return [Number(x.customerId), x];
      }));
      var namedList = data.applyCustomerList || data.applyCustomerVOList || data.customerList || data.applyCustomers;
      if (Array.isArray(namedList) && namedList.length) {
        namedList.forEach(function (row) {
          var cid = Number(row.customerId != null ? row.customerId : row.id);
          if (!Number.isNaN(cid)) {
            var name = row.appName || row.name || row.customerName;
            byId.set(cid, {
              customerId: cid,
              appName: name ? String(name) : "\u5BA2\u6237 ".concat(cid)
            });
          }
        });
      } else {
        var ids = Array.isArray(data.applyCustomerIds) ? data.applyCustomerIds.map(Number) : [];
        ids.forEach(function (cid) {
          if (!Number.isNaN(cid) && !byId.has(cid)) {
            byId.set(cid, {
              customerId: cid,
              appName: "\u5BA2\u6237 ".concat(cid)
            });
          }
        });
      }
      this.customerOptions = Array.from(byId.values());
    },
    applyActivityDetailToForm: function applyActivityDetailToForm(data) {
      var _this3 = this;
      if (!data) return;
      var fd = defaultFormData();
      fd.activityName = data.activityName != null ? String(data.activityName) : '';
      fd.goodsType = data.productType != null ? String(data.productType) : '';
      if (data.startTime && data.endTime) {
        fd.activityTime = this.normalizeSameDayActivityTime([data.startTime, data.endTime]);
      }
      fd.id = data.id != null ? String(data.id) : '';
      fd.exchangeMode = this.exchangeTypeToMode(data.exchangeType);
      if (String(fd.goodsType) === '3') {
        fd.exchangeMode = 'POINTS_ONLY';
      }
      var rawAct = data.applyCustomerType;
      if (rawAct != null && rawAct !== '' && !Number.isNaN(Number(rawAct))) {
        var n = Number(rawAct);
        fd.applyCustomerType = n === 0 ? 0 : 1;
      } else if (Array.isArray(data.applyCustomerIds) && data.applyCustomerIds.length) {
        fd.applyCustomerType = 1;
      } else {
        fd.applyCustomerType = 0;
      }
      if (fd.applyCustomerType === 1 && Array.isArray(data.applyCustomerIds) && data.applyCustomerIds.length) {
        fd.customerScope = data.applyCustomerIds.map(function (x) {
          return Number(x);
        });
      }
      var cardRt = Number(data.cardRightType);
      if (cardRt === 1 && Array.isArray(data.cardRightIds) && data.cardRightIds.length) {
        fd.cardPermissionIds = data.cardRightIds.map(function (x) {
          return Number(x);
        });
      }
      var details = Array.isArray(data.details) ? data.details : [];
      if (fd.exchangeMode === 'POINTS_CASH' && details.length) {
        var d0 = details[0];
        fd.simpleRule = {
          pointsPercent: d0.integralPercent,
          cashPercent: d0.otherPayPercent,
          integralPerYuan: d0.integralPerYuan
        };
      } else if (fd.exchangeMode === 'POINTS_ONLY' && details.length) {
        var _d = details[0];
        fd.integralPerYuan = _d.integralPerYuan;
      } else if (fd.exchangeMode === 'POINTS_CARD_CASH') {
        fd.fukaRuleRows = this.buildFukaRowsFromDetails(details);
      }
      details.forEach(function (d) {
        if (!d) return;
        if (Array.isArray(d.cardIds)) {
          d.cardIds.forEach(function (cid) {
            var id = Number(cid);
            if (!Number.isNaN(id) && !_this3.cardMetaMap[id]) {
              _this3.$set(_this3.cardMetaMap, id, {
                id: id,
                card_name: ''
              });
            }
          });
        }
        if (d.cardId != null && d.cardName) {
          var cid = Number(d.cardId);
          _this3.$set(_this3.cardMetaMap, cid, {
            id: cid,
            card_name: String(d.cardName)
          });
        }
      });
      this.formData = fd;
      this.mergeCustomerOptionsFromDetail(data);
    },
    loadActivityDetail: function () {
      var _loadActivityDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(routeId) {
        var token, data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              token = ++this.detailRequestToken;
              this.detailLoading = true;
              _context.p = 1;
              _context.n = 2;
              return (0, _shopIntegralApi.shopIntegralActivityInfoApi)(routeId);
            case 2:
              data = _context.v;
              if (!(token !== this.detailRequestToken)) {
                _context.n = 3;
                break;
              }
              return _context.a(2);
            case 3:
              this.applyActivityDetailToForm(data);
              if (this.mode === 'copy') {
                this.formData.id = '';
                this.formData.activityName = '';
                this.formData.goodsType = '';
                this.formData.activityTime = [];
              }
              _context.n = 4;
              return this.searchCardPermissionOptions('');
            case 4:
              _context.p = 4;
              if (token === this.detailRequestToken) {
                this.detailLoading = false;
              }
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1,, 4, 5]]);
      }));
      function loadActivityDetail(_x) {
        return _loadActivityDetail.apply(this, arguments);
      }
      return loadActivityDetail;
    }(),
    searchCardPermissionOptions: function () {
      var _searchCardPermissionOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(keyword) {
        var _this4 = this;
        var res, list;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.cardPermLoading = true;
              _context2.p = 1;
              _context2.n = 2;
              return (0, _cardCouponApi.getFucardList)(keyword);
            case 2:
              res = _context2.v;
              list = res || [];
              this.cardPermissionOptions = list;
              list.forEach(function (item) {
                if (item && item.id != null) {
                  _this4.$set(_this4.cardMetaMap, item.id, item);
                }
              });
            case 3:
              _context2.p = 3;
              this.cardPermLoading = false;
              return _context2.f(3);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[1,, 3, 4]]);
      }));
      function searchCardPermissionOptions(_x2) {
        return _searchCardPermissionOptions.apply(this, arguments);
      }
      return searchCardPermissionOptions;
    }(),
    onCardPermissionChange: function onCardPermissionChange() {
      var allowed = new Set(this.formData.cardPermissionIds);
      this.formData.fukaRuleRows.forEach(function (row) {
        if (row.fukaIds && row.fukaIds.length) {
          row.fukaIds = row.fukaIds.filter(function (id) {
            return allowed.has(id);
          });
        }
      });
    },
    onGoodsTypeChange: function onGoodsTypeChange() {
      if (String(this.formData.goodsType) === '3') {
        this.formData.exchangeMode = 'POINTS_ONLY';
        this.onExchangeModeChange();
      }
    },
    onExchangeModeChange: function onExchangeModeChange() {
      if (this.formData.exchangeMode !== 'POINTS_CARD_CASH') {
        this.formData.fukaRuleRows = [defaultFukaRow()];
      }
    },
    onFukaRowChange: function onFukaRowChange() {
      // 互斥由 availableIdsForFukaRow 控制下拉可选范围
    },
    /** 本行可选：卡片权限内，且未被其它行选中的福卡；本行已选的始终保留在下拉里以便展示 label */availableIdsForFukaRow: function availableIdsForFukaRow(rowIndex) {
      var perm = this.formData.cardPermissionIds || [];
      var otherTaken = new Set();
      this.formData.fukaRuleRows.forEach(function (r, i) {
        if (i !== rowIndex && r.fukaIds && r.fukaIds.length) {
          r.fukaIds.forEach(function (id) {
            return otherTaken.add(id);
          });
        }
      });
      var row = this.formData.fukaRuleRows[rowIndex];
      var current = row && row.fukaIds || [];
      var currentSet = new Set(current);
      return perm.filter(function (id) {
        return !otherTaken.has(id) || currentSet.has(id);
      });
    },
    /** 福卡类选项/表单项展示：名称后接 -卡片id：id */cardPermissionOptionLabel: function cardPermissionOptionLabel(item) {
      var name = item && item.card_name != null ? String(item.card_name) : '';
      var id = item && item.id != null ? item.id : '';
      return "".concat(name, " ID\uFF1A").concat(id);
    },
    fukaFormItemLabel: function fukaFormItemLabel(row) {
      var ids = row && row.fukaIds && row.fukaIds.length ? row.fukaIds.join('、') : '';
      return ids ? "\u798F\u5361 ID\uFF1A".concat(ids) : '福卡 ID：';
    },
    cardLabel: function cardLabel(id) {
      var m = this.cardMetaMap[id];
      if (m && m.card_name) {
        return "".concat(m.card_name, " ID\uFF1A").concat(id);
      }
      return "\u798F\u5361 ID\uFF1A".concat(id);
    },
    addFukaRuleRow: function addFukaRuleRow() {
      if (this.formData.fukaRuleRows.length >= 10) {
        this.$message.warning('最多添加10条福卡规则');
        return;
      }
      this.formData.fukaRuleRows.push(defaultFukaRow());
    },
    removeFukaRuleRow: function removeFukaRuleRow(index) {
      this.formData.fukaRuleRows.splice(index, 1);
    },
    searchCustomerOptions: function () {
      var _searchCustomerOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(keyword) {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              this.customerLoading = true;
              _context3.p = 1;
              _context3.n = 2;
              return (0, _customerOrderApi.companyappAutoListApi)({
                keyword: keyword
              });
            case 2:
              res = _context3.v;
              this.customerOptions = res || [];
            case 3:
              _context3.p = 3;
              this.customerLoading = false;
              return _context3.f(3);
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this, [[1,, 3, 4]]);
      }));
      function searchCustomerOptions(_x3) {
        return _searchCustomerOptions.apply(this, arguments);
      }
      return searchCustomerOptions;
    }(),
    isValidPercent1To100: function isValidPercent1To100(v) {
      var n = Number(v);
      return Number.isInteger(n) && n >= 1 && n <= 100;
    },
    /** 1 元兑换多少积分，须为正整数 */isValidIntegralPerYuan: function isValidIntegralPerYuan(v) {
      var n = Number(v);
      return Number.isInteger(n) && n >= 1;
    },
    /**
     * 消耗积分% / 现金(或现金·福豆)% 联动：改一侧则用 100 减出另一侧。
     * 返回 { skip: true }：当前为空（用户清空），不改不写；
     * 返回 { invalid: true }：无法配平（含 >100、或补数非 1～100），已提示，应清空两项；
     * 返回 { other: n }：合法补数。
     */
    applyComplementPercent: function applyComplementPercent(currentVal) {
      if (currentVal == null || currentVal === '') {
        return {
          skip: true
        };
      }
      var n = Number(currentVal);
      if (!Number.isFinite(n)) {
        this.$message.warning('请输入 1～100 的整数，保证两项之和为 100%');
        return {
          invalid: true
        };
      }
      var other = 100 - n;
      if (other < 0) {
        this.$message.warning('请输入 0～100 的值');
        return {
          invalid: true
        };
      }
      if (!this.isValidPercent1To100(other)) {
        this.$message.warning('请输入 1～100 的整数，保证两项之和为 100%');
        return {
          invalid: true
        };
      }
      return {
        other: other
      };
    },
    onSimpleRulePointsPercentChange: function onSimpleRulePointsPercentChange(val) {
      var _this5 = this;
      if (this._syncingExchangePercent) return;
      var r = this.applyComplementPercent(val);
      if (r.skip) return;
      if (r.invalid) {
        this._syncingExchangePercent = true;
        this.formData.simpleRule.pointsPercent = undefined;
        this.formData.simpleRule.cashPercent = undefined;
        this.$nextTick(function () {
          _this5._syncingExchangePercent = false;
        });
        return;
      }
      this._syncingExchangePercent = true;
      this.formData.simpleRule.cashPercent = r.other;
      this.$nextTick(function () {
        _this5._syncingExchangePercent = false;
      });
    },
    onSimpleRuleCashPercentChange: function onSimpleRuleCashPercentChange(val) {
      var _this6 = this;
      if (this._syncingExchangePercent) return;
      var r = this.applyComplementPercent(val);
      if (r.skip) return;
      if (r.invalid) {
        this._syncingExchangePercent = true;
        this.formData.simpleRule.pointsPercent = undefined;
        this.formData.simpleRule.cashPercent = undefined;
        this.$nextTick(function () {
          _this6._syncingExchangePercent = false;
        });
        return;
      }
      this._syncingExchangePercent = true;
      this.formData.simpleRule.pointsPercent = r.other;
      this.$nextTick(function () {
        _this6._syncingExchangePercent = false;
      });
    },
    onFukaRowPointsPercentChange: function onFukaRowPointsPercentChange(rowIndex, val) {
      var _this7 = this;
      if (this._syncingExchangePercent) return;
      var r = this.applyComplementPercent(val);
      if (r.skip) return;
      var row = this.formData.fukaRuleRows[rowIndex];
      if (!row) return;
      if (r.invalid) {
        this._syncingExchangePercent = true;
        row.pointsPercent = undefined;
        row.cashPercent = undefined;
        this.$nextTick(function () {
          _this7._syncingExchangePercent = false;
        });
        return;
      }
      this._syncingExchangePercent = true;
      row.cashPercent = r.other;
      this.$nextTick(function () {
        _this7._syncingExchangePercent = false;
      });
    },
    onFukaRowCashPercentChange: function onFukaRowCashPercentChange(rowIndex, val) {
      var _this8 = this;
      if (this._syncingExchangePercent) return;
      var r = this.applyComplementPercent(val);
      if (r.skip) return;
      var row = this.formData.fukaRuleRows[rowIndex];
      if (!row) return;
      if (r.invalid) {
        this._syncingExchangePercent = true;
        row.pointsPercent = undefined;
        row.cashPercent = undefined;
        this.$nextTick(function () {
          _this8._syncingExchangePercent = false;
        });
        return;
      }
      this._syncingExchangePercent = true;
      row.pointsPercent = r.other;
      this.$nextTick(function () {
        _this8._syncingExchangePercent = false;
      });
    },
    validateStep2: function validateStep2() {
      if (!this.formData.activityName || String(this.formData.activityName).trim() === '') {
        this.$message.warning('请输入活动名称，不能只填空格');
        return false;
      }
      if (!this.formData.cardPermissionIds.length) {
        this.$message.warning('请选择卡片权限');
        return false;
      }
      if (Number(this.formData.applyCustomerType) === 1) {
        if (!this.formData.customerScope.length) {
          this.$message.warning('请选择适用分销客户');
          return false;
        }
      }
      var mode = this.formData.exchangeMode;
      if (this.isCouponGoodsType && mode !== 'POINTS_ONLY') {
        this.$message.warning('优惠券商品仅支持纯积分兑换');
        return false;
      }
      if (mode === 'POINTS_CASH') {
        var _this$formData$simple = this.formData.simpleRule,
          pointsPercent = _this$formData$simple.pointsPercent,
          cashPercent = _this$formData$simple.cashPercent;
        if (!this.isValidPercent1To100(pointsPercent) || !this.isValidPercent1To100(cashPercent)) {
          this.$message.warning('请填写「消耗积分」与「现金支付」比例，且须为 1～100 的整数');
          return false;
        }
        if (Number(pointsPercent) + Number(cashPercent) !== 100) {
          this.$message.warning('「消耗积分」与「现金支付」比例相加须等于 100%');
          return false;
        }
        if (!this.isValidIntegralPerYuan(this.formData.simpleRule.integralPerYuan)) {
          this.$message.warning('请填写「1元 = ? 积分」，且须为正整数');
          return false;
        }
      } else if (mode === 'POINTS_ONLY') {
        if (!this.isValidIntegralPerYuan(this.formData.integralPerYuan)) {
          this.$message.warning('请填写「1元 = ? 积分」，且须为正整数');
          return false;
        }
      } else if (mode === 'POINTS_CARD_CASH') {
        for (var i = 0; i < this.formData.fukaRuleRows.length; i++) {
          var row = this.formData.fukaRuleRows[i];
          if (!row.fukaIds || !row.fukaIds.length) {
            this.$message.warning("\u8BF7\u9009\u62E9\u7B2C ".concat(i + 1, " \u7EC4\u7684\u798F\u5361"));
            return false;
          }
          if (!this.isValidPercent1To100(row.pointsPercent) || !this.isValidPercent1To100(row.cashPercent)) {
            this.$message.warning("\u7B2C ".concat(i + 1, " \u7EC4\u8BF7\u586B\u5199\u300C\u6D88\u8017\u79EF\u5206\u300D\u4E0E\u300C\u73B0\u91D1/\u798F\u8C46\u652F\u4ED8\u300D\u6BD4\u4F8B\uFF0C\u4E14\u987B\u4E3A 1\uFF5E100 \u7684\u6574\u6570"));
            return false;
          }
          if (Number(row.pointsPercent) + Number(row.cashPercent) !== 100) {
            this.$message.warning("\u7B2C ".concat(i + 1, " \u7EC4\uFF1A\u300C\u6D88\u8017\u79EF\u5206\u300D\u4E0E\u300C\u73B0\u91D1/\u798F\u8C46\u652F\u4ED8\u300D\u6BD4\u4F8B\u76F8\u52A0\u987B\u7B49\u4E8E 100%"));
            return false;
          }
          if (!this.isValidIntegralPerYuan(row.integralPerYuan)) {
            this.$message.warning("\u7B2C ".concat(i + 1, " \u7EC4\u8BF7\u586B\u5199\u300C1\u5143 = ? \u79EF\u5206\u300D\uFF0C\u4E14\u987B\u4E3A\u6B63\u6574\u6570"));
            return false;
          }
        }
      }
      return true;
    },
    nextStep: function nextStep() {
      var _this9 = this;
      if (this.isView) {
        if (this.currentStep < 1) this.currentStep += 1;
        return;
      }
      if (this.currentStep === 0) {
        this.$refs.baseForm.validate(function (valid) {
          if (!valid) return;
          if (String(_this9.formData.goodsType) === '3') {
            _this9.formData.exchangeMode = 'POINTS_ONLY';
            _this9.onExchangeModeChange();
          }
          _this9.currentStep += 1;
        });
      }
    },
    prevStep: function prevStep() {
      if (this.currentStep > 0) this.currentStep -= 1;
    },
    /** 数字表单项：≥min 的整数才视为用户已填（避免 el-input-number 空态为 0 误判） */isMeaningfulPositiveIntField: function isMeaningfulPositiveIntField(val) {
      var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      if (val === '' || val == null) return false;
      var n = Number(val);
      return !Number.isNaN(n) && Number.isInteger(n) && n >= min;
    },
    /** 是否有已填写内容（有则取消需二次确认） */hasExchangeOperateFormFilled: function hasExchangeOperateFormFilled() {
      if (this.currentStep > 0) return true;
      var fd = this.formData;
      if ((fd.activityName || '').trim() !== '') return true;
      if (fd.goodsType !== '' && fd.goodsType != null) return true;
      var at = fd.activityTime || [];
      if (at.length >= 2 && at[0] && at[1]) return true;
      if (fd.cardPermissionIds && fd.cardPermissionIds.length) return true;
      if (fd.customerScope && fd.customerScope.length) return true;
      /** 新建默认兑换方式为 POINTS_CARD_CASH，仅当改选「纯积分」或「积分+现金」时视为有修改 */
      if (fd.exchangeMode === 'POINTS_ONLY' || fd.exchangeMode === 'POINTS_CASH') return true;
      var sr = fd.simpleRule || {};
      if (this.isMeaningfulPositiveIntField(sr.pointsPercent)) return true;
      if (this.isMeaningfulPositiveIntField(sr.cashPercent)) return true;
      if (this.isMeaningfulPositiveIntField(sr.integralPerYuan)) return true;
      if (this.isMeaningfulPositiveIntField(fd.integralPerYuan)) return true;
      var rows = fd.fukaRuleRows || [];
      if (rows.length > 1) return true;
      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        if (row.fukaIds && row.fukaIds.length) return true;
        if (this.isMeaningfulPositiveIntField(row.pointsPercent)) return true;
        if (this.isMeaningfulPositiveIntField(row.cashPercent)) return true;
        if (this.isMeaningfulPositiveIntField(row.integralPerYuan)) return true;
      }
      return false;
    },
    onApplyCustomerTypeChange: function onApplyCustomerTypeChange(val) {
      if (Number(val) === 0) {
        this.formData.customerScope = [];
      }
    },
    handleCancel: function handleCancel() {
      var _this0 = this;
      if (this.isView) {
        void this.closeOperateTabAndGoExchangeList();
        return;
      }
      if (!this.hasExchangeOperateFormFilled()) {
        void this.closeOperateTabAndGoExchangeList();
        return;
      }
      this.$confirm('取消后全部数据不保留,是否取消?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        return _this0.closeOperateTabAndGoExchangeList();
      }).catch(function () {});
    },
    navigateToExchangeList: function navigateToExchangeList() {
      this.$router.push({
        path: '/integral/exchangeConfig'
      });
    },
    /** 确认取消：关闭当前标签并进入积分兑换配置列表 */closeOperateTabAndGoExchangeList: function () {
      var _closeOperateTabAndGoExchangeList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return this.$store.dispatch('tagsView/delView', this.$route);
            case 1:
              _context4.n = 2;
              return this.$nextTick();
            case 2:
              _context4.n = 3;
              return this.$router.replace({
                path: '/integral/exchangeConfig'
              });
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function closeOperateTabAndGoExchangeList() {
        return _closeOperateTabAndGoExchangeList.apply(this, arguments);
      }
      return closeOperateTabAndGoExchangeList;
    }(),
    /** details：integralPercent、otherPayPercent、cardIds（积分+现金/纯积分可为空数组） */buildExchangeDetails: function buildExchangeDetails() {
      var fd = this.formData;
      var mode = fd.exchangeMode;
      if (mode === 'POINTS_CASH') {
        var p = Number(fd.simpleRule.pointsPercent);
        var c = Number(fd.simpleRule.cashPercent);
        return [{
          integralPercent: p,
          otherPayPercent: c,
          cardIds: [],
          integralPerYuan: Number(fd.simpleRule.integralPerYuan)
        }];
      }
      if (mode === 'POINTS_ONLY') {
        return [{
          integralPercent: 100,
          otherPayPercent: 0,
          cardIds: [],
          integralPerYuan: Number(fd.integralPerYuan)
        }];
      }
      var details = [];
      (fd.fukaRuleRows || []).forEach(function (row) {
        var ids = (row.fukaIds || []).map(function (id) {
          return Number(id);
        }).filter(function (id) {
          return !Number.isNaN(id);
        });
        if (!ids.length) return;
        details.push({
          integralPercent: Number(row.pointsPercent),
          otherPayPercent: Number(row.cashPercent),
          cardIds: ids,
          integralPerYuan: Number(row.integralPerYuan)
        });
      });
      return details;
    },
    /** 仅当同一天且开始与结束完整时间一致时，改为当天 00:00:00～23:59:59 */normalizeSameDayActivityTime: function normalizeSameDayActivityTime(val) {
      if (!val || !Array.isArray(val) || val.length !== 2) return val;
      var a = val[0];
      var b = val[1];
      if (a == null || b == null || a === '' || b === '') return val;
      var sa = String(a).trim();
      var sb = String(b).trim();
      var dateA = sa.length >= 10 ? sa.slice(0, 10) : '';
      var dateB = sb.length >= 10 ? sb.slice(0, 10) : '';
      if (!dateA || !dateB || dateA !== dateB) return val;
      if (sa !== sb) return val;
      return ["".concat(dateA, " 00:00:00"), "".concat(dateB, " 23:59:59")];
    },
    /** 开始、结束均不得早于当前时刻；若结束早于开始则与开始对齐 */clampActivityTimeFromNow: function clampActivityTimeFromNow(val) {
      if (!val || !Array.isArray(val) || val.length !== 2) return val;
      var a = val[0];
      var b = val[1];
      if (a == null || b == null || a === '' || b === '') return val;
      var fmt = function fmt(d) {
        var p = function p(n) {
          return String(n).padStart(2, '0');
        };
        return "".concat(d.getFullYear(), "-").concat(p(d.getMonth() + 1), "-").concat(p(d.getDate()), " ").concat(p(d.getHours()), ":").concat(p(d.getMinutes()), ":").concat(p(d.getSeconds()));
      };
      var parse = function parse(s) {
        return new Date(String(s).replace(/-/g, '/'));
      };
      var now = new Date();
      var da = parse(a);
      var db = parse(b);
      if (Number.isNaN(da.getTime()) || Number.isNaN(db.getTime())) return val;
      if (da.getTime() < now.getTime()) da = new Date(now);
      if (db.getTime() < now.getTime()) db = new Date(now);
      if (da.getTime() > db.getTime()) db = new Date(da);
      return [fmt(da), fmt(db)];
    },
    onActivityTimeChange: function onActivityTimeChange(val) {
      var next = this.normalizeSameDayActivityTime(val);
      next = this.clampActivityTimeFromNow(next);
      this.formData.activityTime = next;
    },
    buildExchangeActivityRequest: function buildExchangeActivityRequest() {
      var fd = this.formData;
      var range = this.normalizeSameDayActivityTime(fd.activityTime || []) || [];
      if (this.mode !== 'edit') {
        range = this.clampActivityTimeFromNow(range) || [];
      }
      var _range = range,
        _range2 = _slicedToArray(_range, 2),
        startTime = _range2[0],
        endTime = _range2[1];
      var applyCustomerType = Number(fd.applyCustomerType) === 0 ? 0 : 1;
      var customerIds = applyCustomerType === 1 && fd.customerScope && fd.customerScope.length ? fd.customerScope.map(function (id) {
        return Number(id);
      }) : undefined;
      var hasCards = fd.cardPermissionIds && fd.cardPermissionIds.length;
      var req = {
        activityName: String(fd.activityName || '').trim(),
        applyCustomerType: applyCustomerType,
        applyCustomerIds: customerIds,
        cardRightType: hasCards ? 1 : 0,
        cardRightIds: hasCards ? fd.cardPermissionIds.map(function (id) {
          return Number(id);
        }) : undefined,
        startTime: startTime,
        endTime: endTime,
        exchangeType: this.isCouponGoodsType ? EXCHANGE_TYPE.POINTS_ONLY : EXCHANGE_TYPE[fd.exchangeMode] || EXCHANGE_TYPE.POINTS_CASH,
        productType: Number(fd.goodsType),
        details: this.buildExchangeDetails()
      };
      if (this.mode === 'edit' && fd.id) {
        req.id = Number(fd.id);
      }
      return req;
    },
    handleSubmit: function () {
      var _handleSubmit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var isEdit, requestBody;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              if (this.validateStep2()) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2);
            case 1:
              isEdit = this.mode === 'edit' && this.formData.id;
              this.submitLoading = true;
              _context5.p = 2;
              requestBody = this.buildExchangeActivityRequest();
              if (!isEdit) {
                _context5.n = 4;
                break;
              }
              _context5.n = 3;
              return (0, _shopIntegralApi.shopIntegralUpdateExchangeActivityApi)(requestBody);
            case 3:
              _context5.n = 5;
              break;
            case 4:
              _context5.n = 5;
              return (0, _shopIntegralApi.shopIntegralAddExchangeActivityApi)(requestBody);
            case 5:
              this.$message.success(isEdit ? '保存成功' : '提交成功');
              this.$closeCompletedView();
              this.navigateToExchangeList();
            case 6:
              _context5.p = 6;
              this.submitLoading = false;
              return _context5.f(6);
            case 7:
              return _context5.a(2);
          }
        }, _callee5, this, [[2,, 6, 7]]);
      }));
      function handleSubmit() {
        return _handleSubmit.apply(this, arguments);
      }
      return handleSubmit;
    }()
  }
};